export default "__VITE_ASSET__e6f83e2d__"